<template>
  <div>
    <b-modal :id="id" centered size="lg" @ok="handleSubmitDistEnquesta" @hidden="hideModalDistEnquesta" :title='$t("admin.enquestes.assignacio.titol")'>
      <b-form ref="formAssignacioEnquesta" @submit.stop.prevent="handleSubmit">

        <b-form-group id="input-group-perfils-csv" :label='$t("admin.enquestes.assignacio.estructuracsv")+":"' label-size="sm" label-cols="4" label-cols-lg="2">
          <b-form-select id="config-perfils-csv" required size="sm" v-model="idConfigPerfil" :options="perfilReaderList">
            <template v-slot:first>
              <b-form-select-option :value="null">-- {{$t("admin.enquestes.assignacio.estructuracsvel")}} --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group label-cols="2" label="Fitxer:" label-for="input-file-csv" description="Fitxer csv amb els usuaris que informaran l'enquesta.">
          <b-form-file v-model="fitxerCsv" placeholder="Seleccioni un fitxer..." size="sm" id="input-file-csv"></b-form-file>
        </b-form-group>

        <b-form-group label-cols="2" label="" label-for="check-elimnar-assignacions-prev">
          <b-form-checkbox v-model="eliminarAssignacionsPrevies" size="sm" name="check-elimnar-assignacions-prev" switch>
            Eliminar assignacions prèvies <span id="tooltip-check-assignacions"><b-icon font-scale="1.5" variant="primary" icon="question-circle"></b-icon></span>
            <b-tooltip target="tooltip-check-assignacions">
              Si activa aquest flag s'eliminaran les assignacions prèvies que pugui tenir l'enquesta. <br>
              Si no l'activa, s'afegiran les assignacions a les ja existents evitant duplicitats.
            </b-tooltip>
          </b-form-checkbox>
        </b-form-group>

      </b-form>

      <b-alert :show="tempsErrorAlerta" fade dismissible variant="danger" @dismissed="tempsErrorAlerta=0" @dismiss-count-down="canviarCompteRegresiva">
        No s'ha pogut processar el fitxer. {{ tempsErrorAlerta }}
      </b-alert>
      <b-alert :show="infoAlerta" fade dismissible variant="info" @dismissed="infoAlerta=false">
        Processant el fitxer, un moment si us plau.
      </b-alert>
      <div class="text-center mt-4" v-if="showSpinnerAssignacions">
        <b-spinner variant="primary"></b-spinner>
      </div>

    </b-modal>
  </div>
</template>

<script>
import enquestaService from "../../services/EnquestaService";
import loginService from "../../services/LoginService";
import configPerfilReaderService from "@/services/ConfigPerfilReaderService";

export default {
  name: "ModalAssignacioEnquesta",
  props: {
    id: {
      type: String,
      required: true
    },
    activacio: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fitxerCsv: null,
      eliminarAssignacionsPrevies: false,
      showSpinnerAssignacions: false,
      infoAlerta: false,
      dismissSecs: 5,
      tempsErrorAlerta: 0,
      idEntitat: 0,
      idConfigPerfil: null,
      perfilReaderList:[]
    };
  },
  methods: {
    async handleSubmitDistEnquesta(bvModalEvt) {
      console.log("Submit - this.idConfigPerfil: "+this.idConfigPerfil);
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      if (this.fitxerCsv === null) return;
      try {
        this.showSpinnerAssignacions = true;
        this.infoAlerta = true;
        const response = await enquestaService.assignarEnquesta(this.activacio, this.idConfigPerfil, this.fitxerCsv, this.eliminarAssignacionsPrevies);

        if (response.status == 200) {
          this.$emit('activacio-assignada', response.data)
          let activacioResponse = response.data;
          this.showSpinnerAssignacions = false;
          this.infoAlerta = false;

          if (activacioResponse.estat == "1") {
            this.hideModalDistEnquesta();
          } else {
            this.mostrarMissatgeAlerta();
          }
        }

      } catch (e) {
        console.log(e);
      }
    },
    hideModalDistEnquesta(bvModalEvt) {
      this.tempsErrorAlerta = 0

      this.fitxerCsv = null;
      this.eliminarAssignacionsPrevies = false;
      // Prevent modal from closing
      if (bvModalEvt) {
        bvModalEvt.preventDefault();
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id)
      })
    },
    checkFormValidity() {
      const valid = this.$refs.formAssignacioEnquesta.checkValidity();
      return valid
    },
    canviarCompteRegresiva(tempsMostrarAlerta) {
      this.tempsErrorAlerta = tempsMostrarAlerta
    },
    mostrarMissatgeAlerta() {
      this.tempsErrorAlerta = this.dismissSecs
    },
    listEstructuresCsv(){
      this.idEntitat = loginService.getIdEntitat();

      configPerfilReaderService.listPerfilReader(this.idEntitat)
          .then(response => {
            this.perfilReaderList = [];
            let i;
            for (i = 0; i < response.data.length; i++) {
              this.perfilReaderList.push({'value':response.data[i].idConfig,'text':response.data[i].descripcio})
            }
          })
          .catch(e => {
            console.log(e);
          });

    },
  },
  mounted() {
    this.listEstructuresCsv();
  }
};
</script>

<style>
</style>